import { queueTrackingEvent } from '@library/tracking-integration'

type NextBoxActions =
  | 'click_next_box_plate'
  | 'click_choose_recipes'
  | 'click_recommended_recipe'
  | 'click_carousel_see_more'
  | 'click_upcoming_boxes'
  | 'carousel_scroll'
  | 'order_next_box_widget_loaded'
  | 'WELCOME_PAGE_LANDED'
  | 'next_order_created'

type OrderSummaryActions = 'click_order_summary'

type AppPromptActions =
  | 'app_download_screen_displayed'
  | 'app_download_cta_click'
  | 'app_download_cta_dismissed'
  | 'AppPromoSection Clicked'
  | 'click_dashboard_cta'

type ActionsNames = NextBoxActions | OrderSummaryActions | AppPromptActions

type Properties = Record<string, unknown>
type FirstOrderWeek = 'primary' | 'secondary' | 'tertiary'

type Common = {
  action: ActionsNames
  properties?: Properties
}

function trackEvent(action: ActionsNames, properties?: Properties) {
  const params = properties ? { action, properties } : { action }

  queueTrackingEvent<Common>(params)
}

export const useWelcomeTracking = () => ({
  trackWelcomePageLanded: ({
    firstOrderWeek,
    newLocation,
  }: {
    firstOrderWeek: FirstOrderWeek
    newLocation: string
  }) =>
    trackEvent('WELCOME_PAGE_LANDED', {
      first_order_week: firstOrderWeek,
      newLocation,
    }),
  trackSecondOrderIsLoaded: ({
    hasSecondOrderLoaded,
    campaignId,
  }: {
    hasSecondOrderLoaded: boolean
    campaignId?: string
  }) =>
    trackEvent('order_next_box_widget_loaded', {
      se_property: !hasSecondOrderLoaded ? 0 : 1,
      discount_structure: campaignId,
    }),
  trackNextOrderIsLoadedWithinPollingLimit: ({
    hasNextOrderLoadedWithinPollingLimit,
  }: {
    hasNextOrderLoadedWithinPollingLimit: boolean
  }) =>
    trackEvent('next_order_created', {
      was_created: !hasNextOrderLoadedWithinPollingLimit ? 0 : 1,
    }),
  trackClickOnPlate: () => trackEvent('click_next_box_plate'),
  trackGoToMyDashboardClick: () => trackEvent('click_dashboard_cta'),
  trackClickOnAppDownloadCTA: () => trackEvent('AppPromoSection Clicked'),
  trackClickOnChooseRecipes: () => trackEvent('click_choose_recipes'),
  trackClickOnSeeMore: () => trackEvent('click_carousel_see_more'),
  trackClickOnViewUpcomingBoxes: () => trackEvent('click_upcoming_boxes'),
  trackScrollCarousel: () => trackEvent('carousel_scroll'),
  trackClickOnRecipeInCarousel: (orderId: string) =>
    trackEvent('click_recommended_recipe', { order_id: orderId }),
  trackUnfoldSummary: ({ isOpen }: { isOpen: boolean }) =>
    trackEvent('click_order_summary', { close: !isOpen, open: isOpen }),
})
